import React, { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Navbar from '@/components/Navbar';
import Home from '@/pages/Home';
import Jobs from '@/pages/Jobs';
import JobDetails from '@/pages/JobDetails';
import Auth from '@/pages/Auth';
import Dashboard from '@/pages/Dashboard';
import CompanyAuth from '@/pages/CompanyAuth';
import CompanyDashboard from '@/pages/CompanyDashboard';
import AdminAuth from '@/pages/AdminAuth';
import AdminDashboard from '@/pages/AdminDashboard';
import CheckoutPage from '@/pages/CheckoutPage';
import PaymentCallback from '@/pages/PaymentCallback';
import PremiumDashboard from '@/pages/PremiumDashboard';
import ResetPassword from '@/pages/ResetPassword';
import Pricing from '@/pages/Pricing';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogin = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Chargement...</div>;
  }

  return (
    <BrowserRouter>
      <AppContent user={user} setUser={setUser} handleLogin={handleLogin} handleLogout={handleLogout} />
    </BrowserRouter>
  );
}

function AppContent({ user, handleLogin, handleLogout }) {
  const location = useLocation();
  // On the home page, the Navbar should appear BELOW the hero banner (rendered inside Home.js)
  const hideTopNavbar = location.pathname === '/';

  return (
    <div className="App min-h-screen bg-slate-50">
      {!hideTopNavbar && <Navbar user={user} onLogout={handleLogout} />}
      <Routes>
        <Route path="/" element={<Home user={user} onLogout={handleLogout} />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/jobs/:id" element={<JobDetails />} />
        <Route path="/tarifs" element={<Pricing />} />
        <Route
          path="/auth"
          element={user ? <Navigate to="/dashboard" /> : <Auth onLogin={handleLogin} />}
        />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/dashboard"
          element={user ? <Dashboard user={user} /> : <Navigate to="/auth" />}
        />
        <Route
          path="/checkout"
          element={user ? <CheckoutPage /> : <Navigate to="/auth" />}
        />
        <Route
          path="/premium"
          element={user ? <PremiumDashboard user={user} /> : <Navigate to="/auth" />}
        />
        <Route path="/payment/callback" element={<PaymentCallback />} />
        <Route path="/company/auth" element={<CompanyAuth />} />
        <Route path="/company/dashboard" element={<CompanyDashboard />} />
        <Route path="/admin/auth" element={<AdminAuth />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
